var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyDataCommonList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33301 21.3333C5.33301 15.4422 10.1086 10.6666 15.9997 10.6666H47.9997C53.8907 10.6666 58.6663 15.4422 58.6663 21.3333V47.9999C58.6663 53.891 53.8907 58.6666 47.9997 58.6666H15.9997C10.1086 58.6666 5.33301 53.891 5.33301 47.9999V21.3333Z",
    fill: "#E1E2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 10.6666C15.9997 7.72107 18.3875 5.33325 21.333 5.33325C24.2785 5.33325 26.6663 7.72107 26.6663 10.6666C26.6663 13.6121 24.2785 15.9999 21.333 15.9999C18.3875 15.9999 15.9997 13.6121 15.9997 10.6666Z",
    fill: "#E1E2E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.333 10.6666C37.333 7.72107 39.7208 5.33325 42.6663 5.33325C45.6119 5.33325 47.9997 7.72107 47.9997 10.6666C47.9997 13.6121 45.6119 15.9999 42.6663 15.9999C39.7208 15.9999 37.333 13.6121 37.333 10.6666Z",
    fill: "#E1E2E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 26.6667C10.666 25.1939 11.8599 24 13.3327 24H18.666C20.1388 24 21.3327 25.1939 21.3327 26.6667V32C21.3327 33.4728 20.1388 34.6667 18.666 34.6667H13.3327C11.8599 34.6667 10.666 33.4728 10.666 32V26.6667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 42.6667C10.666 41.1939 11.8599 40 13.3327 40H18.666C20.1388 40 21.3327 41.1939 21.3327 42.6667V48C21.3327 49.4728 20.1388 50.6667 18.666 50.6667H13.3327C11.8599 50.6667 10.666 49.4728 10.666 48V42.6667Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.666 26.6667C26.666 25.1939 27.8599 24 29.3327 24H34.666C36.1388 24 37.3327 25.1939 37.3327 26.6667V32C37.3327 33.4728 36.1388 34.6667 34.666 34.6667H29.3327C27.8599 34.6667 26.666 33.4728 26.666 32V26.6667Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.666 42.6667C42.666 41.1939 43.8599 40 45.3327 40H50.666C52.1388 40 53.3327 41.1939 53.3327 42.6667V48C53.3327 49.4728 52.1388 50.6667 50.666 50.6667H45.3327C43.8599 50.6667 42.666 49.4728 42.666 48V42.6667Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.666 26.6667C42.666 25.1939 43.8599 24 45.3327 24H50.666C52.1388 24 53.3327 25.1939 53.3327 26.6667V32C53.3327 33.4728 52.1388 34.6667 50.666 34.6667H45.3327C43.8599 34.6667 42.666 33.4728 42.666 32V26.6667Z",
    fill: "#B1B8C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.666 42.6667C26.666 41.1939 27.8599 40 29.3327 40H34.666C36.1388 40 37.3327 41.1939 37.3327 42.6667V48C37.3327 49.4728 36.1388 50.6667 34.666 50.6667H29.3327C27.8599 50.6667 26.666 49.4728 26.666 48V42.6667Z",
    fill: "#B1B8C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDataCommonList);
export default __webpack_public_path__ + "static/media/EmptyData-CommonList.91199445f9218542b67911ae718b2879.svg";
export { ForwardRef as ReactComponent };